import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter, matchPath } from "react-router-dom";
import { useEffect } from "react";
import {
  lockAppUntilAccountAddressUpdated,
  lockAppUntilAccount2FaEnabled,
  getUserId,
} from "../../utilities/localStorage";
import { uiNotification } from "../../services/UINotificationService";
import { useCurrentAccountQuery } from "../../api/queries/useAccountQuery";
import { WORKSPACE_STATUS } from "../../consts/api";

const ALLOWED_ROUTES = [
  // Added allowed routes for on hold or canceled account status
  "/settings/manage-subscription",
  "/settings/manage-invoices",
  "/settings/resource-usage",
  "/dashboard/user-logs",
  "/settings/manage-subscription-upgrade",
];
const ALLOWED_ROUTES_PROFILE = [
  // Added allowed routes for disabled 2FA status
  "/settings/profile",
  "/logout",
];

const ALLOWED_ROUTES_WORKSPACE = [
  // Added allowed routes until workspace is selected
  "/workspaces",
  "/logout",
];

const REDIRECT_TO = ALLOWED_ROUTES[0];

function AccountStatusRedirect({
  isAccountOnHold,
  isAccountCancelled,
  isAccount2FaEnabled,
  history,
  location,
}) {
  const { data: account } = useCurrentAccountQuery();

  useEffect(() => {
    const isLoggedIn = Boolean(getUserId());
    const pathname = location.pathname;

    if (
      !isLoggedIn &&
      !matchPath(pathname, { path: ALLOWED_ROUTES_WORKSPACE })
    ) {
      return history.push(ALLOWED_ROUTES_WORKSPACE[0]);
    } else if (
      (isAccountOnHold || isAccountCancelled) &&
      !matchPath(pathname, { path: ALLOWED_ROUTES }) &&
      !lockAppUntilAccountAddressUpdated.get()
    ) {
      return history.push(REDIRECT_TO);
    } else if (
      lockAppUntilAccount2FaEnabled.get() &&
      !isAccount2FaEnabled &&
      account?.globalSettings?.accountStatus === WORKSPACE_STATUS.active &&
      !matchPath(pathname, { path: ALLOWED_ROUTES_PROFILE })
    ) {
      uiNotification.error("Action Needed: Enable 2FA");
      return history.push(ALLOWED_ROUTES_PROFILE[0]);
    }
  }, [
    location.pathname,
    account?.globalSettings?.accountStatus,
    isAccount2FaEnabled,
    isAccountOnHold,
    isAccountCancelled,
  ]);

  return null;
}

function mapStateToProps(state) {
  return {
    isAccountOnHold: state.AccountHoldRedirectReducer.isAccountOnHold,
    isAccountCancelled: state.AccountHoldRedirectReducer.isAccountCancelled,
    isAccount2FaEnabled: state.AccountHoldRedirectReducer.isAccount2FaEnabled,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AccountStatusRedirect),
);
